/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcademicUserNameDTO
 */
export interface AcademicUserNameDTO {
    /**
     * 
     * @type {string}
     * @memberof AcademicUserNameDTO
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof AcademicUserNameDTO
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AcademicUserNameDTO
     */
    email?: string | null;
}

export function AcademicUserNameDTOFromJSON(json: any): AcademicUserNameDTO {
    return AcademicUserNameDTOFromJSONTyped(json, false);
}

export function AcademicUserNameDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcademicUserNameDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function AcademicUserNameDTOToJSON(value?: AcademicUserNameDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'email': value.email,
    };
}

